import { Typography } from "antd";

export const LabeledField = ({
  label,
  children,
  required = false,
  extra = null,
}) => (
  <div>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px",
      }}
    >
      <div style={{ display: "inline-flex" }}>
        <Typography.Text
          style={{
            fontWeight: 500,
            fontFamily: "AvenirLTProMedium",
          }}
        >
          {label}
        </Typography.Text>
        {required && (
          <Typography.Text type="danger" style={{ marginLeft: 4 }}>
            *
          </Typography.Text>
        )}
      </div>
      {extra && extra}
    </div>
    {children}
  </div>
);
